import React from 'react';
import { Route, NavLink } from 'react-router-dom';

import ManageCommission from '../ManageCommition';

import HomePage from '../Home';
import Dashboard from '../Dashboard';
import Admin from '../Admin';
import GManager from '../GManager';
import Distributor from '../Distributor';
import Employees from '../Employees';
import StoreOwners from '../StoreOwners';
import StoreTagMapping from '../StoreTagMapping';
import StoreChannelPartner from '../StoreChannelPartner';

import Royalty from '../Royalty';
import BonusPayout from '../BonusPayout';
import Orders from '../Orders';
import Earning from '../Earning';
import ReferralData from '../ReferralData';
import Notifications from '../Notifications';
import DepositeConfirmation from '../DepositeConfirmation';

import TransactionHistory from '../UsersWallet/TransactionHistory';
import WalletCredits from '../AdminWallet/WalletCredits';
import WalletSummary from '../AdminWallet/WalletSummary';
import PartnerWalletManagement from '../AdminWallet/PartnerWalletManagement';

import MappingHistory from '../MappingHistory';
import Mapping from '../Mapping';

import ActivationSummary from '../ActivationSummary';
import StoreActivation from '../StoreActivation';

import ViewProfile from '../ViewProfile';
import Profile from '../Profile';
import TopSellers from '../TopSellers';
import RefferStore from '../RefferStore';
import Training from '../Training';
import Help from '../Help';
import Download from '../Download';
import Storetag from '../Storetag';
import GiftCards from '../GiftCards';
import QwikCilverNonAmazon from '../GiftCards/QwikCilverNonAmazon';
import GiftCardsHistory from '../GiftCards/GiftCardsHistory';
import Migrations from '../Migrations';

import Sales from '../Sales';
import SalesOrderNotification from '../SalesOrderNotification';
import GCAccounts from '../GCAccounts';
import GCCategory from '../GCCategory';
import GCSlugs from '../GCSlugs';
import GCTransactions from '../GCTransactions';
import InstaUsers from '../InstaUsers';
import InstaOrders from '../InstaOrders';
import InstaBanners from '../InstaBanners';
import InstaTransaction from '../InstaTransaction';
import GCReports from '../GCReports';
import DailyWalletReport from '../GCReports/DailyWalletReport';
import MyDailyWalletReport from '../UsersWallet/DailyWalletReport';

import AllGCList from '../GiftCards/all-gc-list';

import TermsConditions from '../Pages/TermsConditions';
import PrivacyPolicy from '../Pages/PrivacyPolicy';
import WebsiteCookiePolicy from '../Pages/WebsiteCookiePolicy';
import RefundPolicy from '../Pages/RefundPolicy';
import ContactUs from '../Pages/ContactUs';
import AmazonPayTC from '../Pages/AmazonPayTC';

import FlipKartProducts from '../AffliateProducts/FlipKart';
import ManageSiteStatus from '../ManageSiteStatus/index';
import CashbackOffers from '../CashbackOffers/index';

import * as ROUTES from 'constants/routes';

export const routeComponents = {
    'terms-conditions': (
        <Route
            exact
            path={ROUTES.TermsConditions}
            component={TermsConditions}
        />
    ),
    'contact-us': <Route exact path={ROUTES.ContactUs} component={ContactUs} />,
    'privacy-policy': (
        <Route exact path={ROUTES.PrivacyPolicy} component={PrivacyPolicy} />
    ),
    'website-cookie-policy': (
        <Route
            exact
            path={ROUTES.WebsiteCookiePolicy}
            component={WebsiteCookiePolicy}
        />
    ),
    'refund-policy': (
        <Route exact path={ROUTES.RefundPolicy} component={RefundPolicy} />
    ),
    'amazon-pay-tc': (
        <Route exact path={ROUTES.AmazonPayTC} component={AmazonPayTC} />
    ),
    'flipkart-products': (
        <Route
            exact
            path={ROUTES.FlipKartProducts}
            component={FlipKartProducts}
        />
    ),
    'cashback-offers': (
        <Route
            exact
            path={ROUTES.CashbackOffers}
            component={CashbackOffers}
        />
    ),
    
    'index': <Route exact path={ROUTES.INDEX} component={Dashboard} />,
    'dashboard': <Route exact path={ROUTES.DASHBOARD} component={Dashboard} />,
    'all-gc-list': (
        <Route exact path={ROUTES.DASHBOARD} component={AllGCList} />
    ),
    'store-tag': <Route exact path={ROUTES.StoreTag} component={Storetag} />,
    'sales': <Route exact path={ROUTES.Sales} component={Sales} />,
    'sales-order-notification': (
        <Route
            exact
            path={ROUTES.SalesOrderNotification}
            component={SalesOrderNotification}
        />
    ),
    'distributor': (
        <Route exact path={ROUTES.Distributor} component={Distributor} />
    ),
    'store-owners': (
        <Route exact path={ROUTES.StoreOwners} component={StoreOwners} />
    ),
    'store-tag-mapping': (
        <Route
            exact
            path={ROUTES.StoreTagMapping}
            component={StoreTagMapping}
        />
    ),
    'store-channel-partner': (
        <Route
            exact
            path={ROUTES.StoreChannelPartner}
            component={StoreChannelPartner}
        />
    ),
    'orders': (
    <Route exact path={ROUTES.Orders} component={Orders} />
    ),
    'earning': (
    <Route exact path={ROUTES.Earning} component={Earning} />
    ),
    'referral-data': (
        <Route exact path={ROUTES.ReferralData} component={ReferralData} />
    ),
    'notifications': (
        <Route exact path={ROUTES.Notifications} component={Notifications} />
    ),
    'mapping-history': (
        <Route exact path={ROUTES.MappingHistory} component={MappingHistory} />
    ),
    'mapping': (
    <Route exact path={ROUTES.Mapping} component={Mapping} />
    ),
    'top-sellars': (
        <Route exact path={ROUTES.TopSellers} component={TopSellers} />
    ),
    'view-profile': (
        <Route exact path={ROUTES.ViewProfile} component={ViewProfile} />
    ),
    'gift-card-history': (
        <Route
            exact
            path={ROUTES.GiftCardsHistory}
            component={GiftCardsHistory}
        />
    ),
    'manage-site-status': (
        <Route
            exact
            path={ROUTES.ManageSiteStatus}
            component={ManageSiteStatus}
        />
    ),
    'gift-cards': <Route exact path={ROUTES.GiftCards} component={GiftCards} />,
    'quick-cilver-non-amazon': (
        <Route
            exact
            path={ROUTES.QwikCilverNonAmazon}
            component={QwikCilverNonAmazon}
        />
    ),
    'deposite-confimation': (
        <Route
            exact
            path={ROUTES.DepositeConfirmation}
            component={DepositeConfirmation}
        />
    ),
    'deposite-confimation-old': (
        <Route
            exact
            path={ROUTES.DepositeConfirmationOLD}
            component={DepositeConfirmation}
        />
    ),
    'gc-accounts': (
        <Route exact path={ROUTES.GCAccounts} component={GCAccounts} />
    ),
    'gc-catalogs': (
        <Route exact path={ROUTES.GCCategory} component={GCCategory} />
    ),
    'gc-slugs': (
        <Route exact path={ROUTES.GCSlugs} component={GCSlugs} />
    ),
    'gift-card-transactions': (
        <Route exact path={ROUTES.GCTransactions} component={GCTransactions} />
    ),
    'insta-orders':(
        <Route exact path={ROUTES.InstaOrders} component={InstaOrders} />
    ),
    'insta-banners':(
        <Route exact path={ROUTES.InstaBanners} component={InstaBanners} />
    ),
    'insta-users': (
        <Route exact path={ROUTES.InstaUsers} component={InstaUsers} />
    ),
    'insta-transaction': (
        <Route exact path={ROUTES.InstaTransaction} component={InstaTransaction} />
    ),
    'gc-reports': <Route exact path={ROUTES.GCReports} component={GCReports} />,
    'daily-wallet-report': (
        <Route
            exact
            path={ROUTES.DailyWalletReport}
            component={DailyWalletReport}
        />
    ),
    'manage-commission': (
        <Route
            exact
            path={ROUTES.ManageCommission}
            component={ManageCommission}
        />
    ),
    'home': <Route exact path={ROUTES.HOME} component={HomePage} />,
    'admin': <Route exact path={ROUTES.Admin} component={Admin} />,
    'g-manager': <Route exact path={ROUTES.GManager} component={GManager} />,
    'employees': <Route exact path={ROUTES.Employees} component={Employees} />,
    'royalty': <Route exact path={ROUTES.Royalty} component={Royalty} />,
    'bonus-payout': (
        <Route exact path={ROUTES.BonusPayout} component={BonusPayout} />
    ),
    'transaction-history': (
        <Route
            exact
            path={ROUTES.TransactionHistory}
            component={TransactionHistory}
        />
    ),
    'wallet-summary': (
        <Route exact path={ROUTES.WalletSummary} component={WalletSummary} />
    ),
    'wallet-credits': (
        <Route exact path={ROUTES.WalletCredits} component={WalletCredits} />
    ),
    'partner-wallet-management': (
        <Route
            exact
            path={ROUTES.PartnerWalletManagement}
            component={PartnerWalletManagement}
        />
    ),
    'gift-cards-history': (
        <Route
            exact
            path={ROUTES.GiftCardsHistory}
            component={GiftCardsHistory}
        />
    ),
    'migrations': <Route exact path={ROUTES.Migrations} component={Migrations} />,
    'my-daily-wallet-report': (
        <Route
            exact
            path={ROUTES.MyDailyWalletReport}
            component={MyDailyWalletReport}
        />
    ),
    'activation-summary': (
        <Route
            exact
            path={ROUTES.ActivationSummary}
            component={ActivationSummary}
        />
    ),
    'store-activation': (
        <Route
            exact
            path={ROUTES.StoreActivation}
            component={StoreActivation}
        />
    ),
    'profile': <Route exact path={ROUTES.Profile} component={Profile} />,
    'reffer-store': (
        <Route exact path={ROUTES.ReferStore} component={RefferStore} />
    ),
    'training': <Route exact path={ROUTES.Training} component={Training} />,
    'help': <Route exact path={ROUTES.Help} component={Help} />,
    'download': <Route exact path={ROUTES.Download} component={Download} />
};

export const footerNavLinks = {
    'terms-conditions': (
        <NavLink exact to={ROUTES.TermsConditions}>
            {' '}
            Terms & Conditions
        </NavLink>
    ),
    'contact-us': (
        <NavLink exact to={ROUTES.ContactUs}>
            {' '}
            Contact Us
        </NavLink>
    ),
    'privacy-policy': (
        <NavLink exact to={ROUTES.PrivacyPolicy}>
            {' '}
            Privacy Policy
        </NavLink>
    ),
    'website-cookie-policy': (
        <NavLink exact to={ROUTES.WebsiteCookiePolicy}>
            {' '}
            Website Cookie Policy
        </NavLink>
    ),
    'refund-policy': (
        <NavLink exact to={ROUTES.RefundPolicy}>
            {' '}
            Cancellation & Refund Policy
        </NavLink>
    ),
    'amazon-pay-tc': (
        <NavLink exact to={ROUTES.AmazonPayTC}>
            {' '}
            Amazon Pay T&C
        </NavLink>
    )
};

export const footerRoutes = [
    'contact-us',
    'terms-conditions',
    'privacy-policy',
    'website-cookie-policy',
    'refund-policy',
    'amazon-pay-tc'
];

export const gmanagerRoutes = [
    'flipkart-products',
    'cashback-offers',
    'index',
    'all-gc-list',
    'store-tag',
    'sales',
    'sales-order-notification',
    'distributor',
    'store-owners',
    'store-tag-mapping',
    'store-channel-partner',
    'orders',
    'earning',
    'referral-data',
    'notifications',
    'mapping-history',
    'mapping',
    'top-sellars',
    'view-profile',
    'gift-card-history',
    'manage-site-status'
];

export const adminRoutes = [
    'manage-site-status',
    'flipkart-products',
    'cashback-offers',
    'deposite-confimation',
    'deposite-confimation-old',
    'gc-accounts',
    'gc-catalogs',
    'gc-slugs',
    'gift-card-transactions',
    'insta-users',
    'insta-orders',
    'insta-banners',
    'insta-transaction',
    'gc-reports',
    'daily-wallet-report',
    'manage-commission',
    'index',
    'dashboard',
    'home',
    'store-tag',
    'sales',
    'sales-order-notification',
    'admin',
    'g-manager',
    'distributor',
    'employees',
    'store-owners',
    'store-tag-mapping',
    'store-channel-partner',
    'royalty',
    'bonus-payout',
    'orders',
    'earning',
    'referral-data',
    'notifications',
    'transaction-history',
    'mapping-history',
    'mapping',
    'top-sellars',
    'view-profile',
    'gift-cards',
    'quick-cilver-non-amazon',
    'gift-cards-history',
    'migrations',
    'wallet-summary',
    'wallet-credits',
    'partner-wallet-management'
];

export const employeesRoutes = [
    'flipkart-products',
    'cashback-offers',
    'deposite-confimation',
    'deposite-confimation-old',
    'sales-order-notification',
    'index',
    'dashboard',
    'distributor',
    'employees',
    'store-owners',
    'store-tag-mapping',
    'store-channel-partner',
    'royalty',
    'bonus-payout',
    'orders',
    'earning',
    'referral-data',
    'notifications',
    'transaction-history',
    'mapping-history',
    'top-sellars',
    'view-profile',
    'gift-cards-history',
    'gift-card-transactions'
];

export const distributorsRoutes = [
    'flipkart-products',
    'cashback-offers',
    'gift-card-transactions',
    'my-daily-wallet-report',
    'deposite-confimation',
    'deposite-confimation-old',
    'sales-order-notification',
    'index',
    'dashboard',
    'activation-summary',
    'store-activation',
    'earning',
    'top-sellars',
    'reffer-store',
    'training',
    'help',
    'download',
    'notifications',
    'transaction-history',
    'gift-cards-history'
];

export const storecpRoutes = [
    'flipkart-products',
    'cashback-offers',
    'my-daily-wallet-report',
    'deposite-confimation',
    'deposite-confimation-old',
    'sales-order-notification',
    'index',
    'dashboard',
    'gift-card-transactions',
    'activation-summary',
    'store-activation',
    'profile',
    'earning',
    'top-sellars',
    'reffer-store',
    'training',
    'help',
    'download',
    'notifications',
    'transaction-history',
    'gift-cards-history',
    'gift-cards'
];

export const storeownersRoutes = [
    'flipkart-products',
    'cashback-offers',
    'my-daily-wallet-report',
    'deposite-confimation',
    'deposite-confimation-old',
    'sales-order-notification',
    'index',
    'dashboard',
    'gift-card-transactions',
    'activation-summary',
    'store-activation',
    'profile',
    'earning',
    'top-sellars',
    'reffer-store',
    'training',
    'help',
    'download',
    'notifications',
    'transaction-history',
    'gift-cards-history'
];
